/**
 * So'z shakllari (demo «Lexo v3»): EN — noto'g'ri fe'llar (V1–V2–V3), RU — fe'l juftlari (НСВ – СВ).
 * id (e0.. / r0..) serverda `user_forms.form_id` — tartibni o'zgartirmang, faqat oxiriga qo'shing.
 */
import { LANG } from '.';

/** [V1, V2, V3, tarjima] */
const FORMS_EN: Array<[string, string, string, string]> = [
  ['be', 'was/were', 'been', 'boʻlmoq'],
  ['have', 'had', 'had', 'ega boʻlmoq'],
  ['do', 'did', 'done', 'qilmoq'],
  ['go', 'went', 'gone', 'bormoq'],
  ['come', 'came', 'come', 'kelmoq'],
  ['see', 'saw', 'seen', 'koʻrmoq'],
  ['eat', 'ate', 'eaten', 'yemoq'],
  ['drink', 'drank', 'drunk', 'ichmoq'],
  ['take', 'took', 'taken', 'olmoq'],
  ['give', 'gave', 'given', 'bermoq'],
  ['make', 'made', 'made', 'yasamoq'],
  ['get', 'got', 'got', 'olmoq (erishmoq)'],
  ['know', 'knew', 'known', 'bilmoq'],
  ['think', 'thought', 'thought', 'oʻylamoq'],
  ['say', 'said', 'said', 'aytmoq'],
  ['tell', 'told', 'told', 'gapirib bermoq'],
  ['buy', 'bought', 'bought', 'sotib olmoq'],
  ['bring', 'brought', 'brought', 'olib kelmoq'],
  ['write', 'wrote', 'written', 'yozmoq'],
  ['read', 'read', 'read', 'oʻqimoq'],
  ['speak', 'spoke', 'spoken', 'gapirmoq'],
  ['find', 'found', 'found', 'topmoq'],
  ['begin', 'began', 'begun', 'boshlamoq'],
  ['run', 'ran', 'run', 'yugurmoq'],
  ['swim', 'swam', 'swum', 'suzmoq'],
  ['sleep', 'slept', 'slept', 'uxlamoq'],
  ['sit', 'sat', 'sat', 'oʻtirmoq'],
  ['stand', 'stood', 'stood', 'turmoq'],
  ['leave', 'left', 'left', 'ketmoq, qoldirmoq'],
  ['forget', 'forgot', 'forgotten', 'unutmoq'],
];
/** [НСВ, СВ, tarjima, tur: p — old qo'shimcha, s — qo'shimcha o'zgaradi, r — boshqa so'z] */
const FORMS_RU: Array<[string, string, string, 'p' | 's' | 'r']> = [
  ['делать', 'сделать', 'qilmoq', 'p'],
  ['писать', 'написать', 'yozmoq', 'p'],
  ['читать', 'прочитать', 'oʻqimoq', 'p'],
  ['пить', 'выпить', 'ichmoq', 'p'],
  ['есть', 'съесть', 'yemoq', 'p'],
  ['видеть', 'увидеть', 'koʻrmoq', 'p'],
  ['слышать', 'услышать', 'eshitmoq', 'p'],
  ['готовить', 'приготовить', 'tayyorlamoq', 'p'],
  ['учить', 'выучить', 'yodlamoq', 'p'],
  ['звонить', 'позвонить', 'qoʻngʻiroq qilmoq', 'p'],
  ['строить', 'построить', 'qurmoq', 'p'],
  ['платить', 'заплатить', 'toʻlamoq', 'p'],
  ['решать', 'решить', 'hal qilmoq', 's'],
  ['покупать', 'купить', 'sotib olmoq', 's'],
  ['давать', 'дать', 'bermoq', 's'],
  ['начинать', 'начать', 'boshlamoq', 's'],
  ['открывать', 'открыть', 'ochmoq', 's'],
  ['закрывать', 'закрыть', 'yopmoq', 's'],
  ['отвечать', 'ответить', 'javob bermoq', 's'],
  ['получать', 'получить', 'olmoq (qabul qilmoq)', 's'],
  ['забывать', 'забыть', 'unutmoq', 's'],
  ['понимать', 'понять', 'tushunmoq', 's'],
  ['помогать', 'помочь', 'yordam bermoq', 's'],
  ['вставать', 'встать', 'turmoq (oʻrnidan)', 's'],
  ['брать', 'взять', 'olmoq (qoʻlga)', 'r'],
  ['говорить', 'сказать', 'aytmoq', 'r'],
  ['класть', 'положить', 'qoʻymoq', 'r'],
  ['ловить', 'поймать', 'tutmoq', 'r'],
  ['садиться', 'сесть', 'oʻtirmoq', 'r'],
  ['искать', 'найти', 'izlamoq → topmoq', 'r'],
];

export interface FormItem { id: string; forms: string[]; uz: string; kind?: 'p' | 's' | 'r' }

export const FM: { title: string; sub: string; labels: string[]; items: FormItem[] } = LANG === 'ru'
  ? { title: 'Feʼl juftlari', sub: 'Tugallanmagan (jarayon) – tugallangan (natija)', labels: ['НСВ · jarayon', 'СВ · natija'],
      items: FORMS_RU.map((r, i) => ({ id: 'r' + i, forms: [r[0], r[1]], uz: r[2], kind: r[3] })) }
  : { title: 'Notoʻgʻri feʼllar', sub: 'V1 – V2 (Past Simple) – V3 (Past Participle)', labels: ['V1', 'V2 · Past', 'V3 · Participle'],
      items: FORMS_EN.map((r, i) => ({ id: 'e' + i, forms: [r[0], r[1], r[2]], uz: r[3] })) };

export const FKIND: Record<'p' | 's' | 'r', string> = { p: 'Old qoʻshimcha bilan', s: 'Qoʻshimcha oʻzgaradi', r: 'Istisno: boshqa soʻz' };
export const fJoin = (x: FormItem) => x.forms.join(' – ');
